import * as React from "react";
import SubscriptionIcons from "../../../../assets/icons/svgIcons/subscriptionIcons";
import {toINR} from "../../../service/numberFormat";

import IPlan from "../IPTypes";
import {IPContext} from "../../infinityPlan";
import gtmService from "../../../service/gtmService";

export default function PlansPricingDesk() {
    const {plans} = React.useContext(IPContext);
    const [charges_show_hide, setCharges_show_hide] = React.useState(false);
    const [Assumptions_show_hide, setAssumptions_show_hide] = React.useState(false);

    return (
        <>
            <ul className="plans_grid">
                <li className="benefits grid_cols">
                    <div className="row_lbl">Benefits</div>
                    {plans.map((plan: IPlan, index: number) => (
                        <div key={index} className={"clr_card " + plan.color}>
                            <p className="name_blk">
                                <label className="pName full_name">{plan.name}</label>
                                {plan.type && (
                                    <label className="pType dBlock full_name">
                                        <span className="hypen">-</span>
                                        {plan.type}
                                    </label>
                                )}
                            </p>
                            {plan.short_name && <p className="pType short_name">{plan.short_name}</p>}
                            <i>
                                <SubscriptionIcons
                                    width="85"
                                    height="60"
                                    icon={(plan.color + "_knot") as "platinum_knot" | "gold_knot" | "black_knot"}
                                />
                            </i>
                            <p className="pValue">
                                <b>₹</b>
                                {toINR(plan.value, 0)}
                            </p>
                        </div>
                    ))}
                </li>
                <li className="grid_cols">
                    <div className="row_lbl">Validity</div>
                    {plans.map((plan: IPlan, index: number) => (
                        <div key={index} className="row_val">
                            {plan.validity}
                        </div>
                    ))}
                </li>
                <li className="grid_cols">
                    <div className="row_lbl">Direct MF</div>
                    {plans.map((plan: IPlan, index: number) => (
                        <div key={index} className="row_val">
                            {plan.direct_MF}
                        </div>
                    ))}
                </li>
                <li className={"grid_cols" + (charges_show_hide ? " sub_grid show" : "")}>
                    <div className="row_lbl">
                        Brokerage (Delivery)
                        <button className="link_button" onClick={() => {
                            gtmService({
                                event: "event Infinity_Subscription_Program",
                                category: "Infinity Subscription",
                                action: "View_All_Charges",
                                labelUrlR: "click"
                            });
                            setCharges_show_hide(!charges_show_hide);
                        }
                        }>
                            {charges_show_hide ? "View Less" : "View All Charges"}
                        </button>
                    </div>
                    {plans.map((plan: IPlan, index: number) => (
                        <div key={index} className="row_val">
                            {plan.brokerage}
                        </div>
                    ))}
                </li>

                <li className={"sub_grid " + (charges_show_hide ? "show" : "hide")}>
                    <ul className="sub_grid_ul">
                        <li className="grid_cols">
                            <div className="row_lbl">Cash Delivery</div>
                            {plans.map((plan: IPlan, index: number) => (
                                <div key={index} className="row_val">
                                    {plan.cash_delivery}
                                </div>
                            ))}
                        </li>
                        <li className="grid_cols">
                            <div className="row_lbl">Intraday & Eq Future</div>
                            {plans.map((plan: IPlan, index: number) => (
                                <div key={index} className="row_val">
                                    {plan.intraday_eq_fut}
                                </div>
                            ))}
                        </li>
                        <li className="grid_cols">
                            <div className="row_lbl">Option (per Lot)</div>
                            {plans.map((plan: IPlan, index: number) => (
                                <div key={index} className="row_val">
                                    {plan.option_per_lot}
                                </div>
                            ))}
                        </li>
                        <li className="grid_cols">
                            <div className="row_lbl">CDS Future</div>
                            {plans.map((plan: IPlan, index: number) => (
                                <div key={index} className="row_val">
                                    {plan.cds_future}
                                </div>
                            ))}
                        </li>
                        <li className="grid_cols">
                            <div className="row_lbl">CDS Option Per Lot</div>
                            {plans.map((plan: IPlan, index: number) => (
                                <div key={index} className="row_val">
                                    {plan.cds_option_per_lot}
                                </div>
                            ))}
                        </li>
                    </ul>
                </li>
                <li className="grid_cols">
                    <div className="row_lbl">
                        Waive off on DP <br/> AMC Charges
                    </div>
                    {plans.map((plan: IPlan, index: number) => (
                        <div key={index} className="row_val">
                            {plan.Waive_off_on_DP_AMC_chrgs}
                        </div>
                    ))}
                </li>
                <li className="grid_cols">
                    <div className="row_lbl">DPC Charges</div>
                    {plans.map((plan: IPlan, index: number) => (
                        <div key={index} className="row_val">
                            {plan.DPC_charges}
                        </div>
                    ))}
                </li>
                <li className="grid_cols">
                    <div className="row_lbl">FNO DPC</div>
                    {plans.map((plan: IPlan, index: number) => (
                        <div key={index} className="row_val">
                            {plan.FNO_DPC}
                        </div>
                    ))}
                </li>
                <li className="grid_cols">
                    <div className="row_lbl">Structured Products AIF setup fees</div>
                    {plans.map((plan: IPlan, index: number) => (
                        <div key={index} className="row_val">
                            {plan.structured_products_AIF_setup_fees}
                            <p>{plan.structured_products_AIF_setup_fees && plan.structured_products_AIF_setup_fees !== "NIL" ? "discount" : ""}</p>
                        </div>
                    ))}
                </li>

                <li className={"grid_cols" + (Assumptions_show_hide ? " show sub_grid" : "")}>
                    <div className="row_lbl">
                        Total Benefits
                        {!Assumptions_show_hide && (
                            <button className="link_button" onClick={() => {
                                {
                                    gtmService({
                                        event: "event Infinity_Subscription_Program",
                                        category: "Infinity Subscription",
                                        action: "Know Assumptions",
                                        labelUrlR: "click"
                                    });
                                    setAssumptions_show_hide(true);
                                }
                            }}>
                                Know Assumptions
                            </button>
                        )}
                    </div>

                    {plans.map((plan: IPlan, index: number) => (
                        <div key={index} className="row_val">
                            <b>₹</b>
                            {toINR(plan.total_benefits)}
                        </div>
                    ))}
                </li>
                <li className={"sub_grid " + (Assumptions_show_hide ? "show" : "hide")}>
                    <ul className="sub_grid_ul">
                        <li className="grid_cols">
                            <div className="row_lbl">Delivery Volume Rs</div>

                            {plans.map((plan: IPlan, index: number) => (
                                <div key={index} className="row_val">
                                    <b>₹</b>
                                    {plan.delivery_volume_rs}
                                </div>
                            ))}
                        </li>

                        <li className="grid_cols">
                            <div className="row_lbl">Minimum Current MF Investment Amount</div>

                            {plans.map((plan: IPlan, index: number) => (
                                <div key={index} className="row_val">
                                    <b>₹</b>
                                    {toINR(plan.min_cur_mf_inv)}
                                </div>
                            ))}
                        </li>
                        <li className="grid_cols">
                            <div className="row_lbl">Monthly SIP Amount</div>

                            {plans.map((plan: IPlan, index: number) => (
                                <div key={index} className="row_val">
                                    <b>₹</b>
                                    {toINR(plan.monthly_sip_amount)}
                                </div>
                            ))}
                        </li>
                        <li className="grid_cols">
                            <div className="row_lbl">Average Debit in Margin Trading</div>

                            {plans.map((plan: IPlan, index: number) => (
                                <div key={index} className="row_val">
                                    {plan.avg_debit_margin_trading ? (
                                        <>
                                            <b>₹</b>
                                            {toINR(plan.avg_debit_margin_trading)}
                                        </>
                                    ) : (
                                        "-"
                                    )}
                                </div>
                            ))}
                        </li>
                        <li className="grid_cols">
                            <div className="row_lbl">
                                Average FNO Margin requirement (FNO positions against pledged stocks)
                                {Assumptions_show_hide && (
                                    <button className="link_button" onClick={() => setAssumptions_show_hide(false)}>
                                        View Less
                                    </button>
                                )}
                            </div>

                            {plans.map((plan: IPlan, index: number) => (
                                <div key={index} className="row_val">
                                    {plan.avg_fno_margin ? (
                                        <>
                                            <b>₹</b>
                                            {toINR(plan.avg_fno_margin)}
                                        </>
                                    ) : (
                                        "-"
                                    )}
                                </div>
                            ))}
                        </li>
                    </ul>
                </li>
                <li className="grid_cols">
                    <div className="row_lbl">Min. Brokerage*</div>

                    {plans.map((plan: IPlan, index: number) => (
                        <div key={index} className="row_val">
                            {plan.min_brokerage}
                        </div>
                    ))}
                </li>

            </ul>
        </>
    );
}
